/* eslint-env browser */
import type React from 'react';
import { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  name: string;
  children: React.ReactNode;
  portalZIndex?: number;
}

function createRootElement(id: string): HTMLDivElement {
  const el = document.createElement('div');
  el.setAttribute('id', id);
  document.body.appendChild(el);
  return el;
}

export function usePortal(id: string, portalZIndex?: number): HTMLElement | null {
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const existingParent = document.querySelector(`#${id}`);
    const el = (existingParent as HTMLDivElement) || createRootElement(id);
    if (portalZIndex) {
      el.style.zIndex = portalZIndex.toString();
      el.style.position = 'relative';
    }
    setContainer(el);
  }, []);

  return container;
}

export function Portal(props: PortalProps): React.ReactPortal | null {
  const { name, children, portalZIndex } = props;
  const container = usePortal(name, portalZIndex);
  if (!container) {
    return null;
  }
  return createPortal(children, container);
}
